<app-photo-galleria
  (hideGallery)="onGalleriaHide()"
  [images]="photoGalleriaImages"
  [showGalleria]="showPhotoGalleriaDialog && photoGalleriaImages?.length > 0"
  [showThumbnails]="!isMobile"
  [activeIndex]="activeGalleryIndex"
  class="photo-galleria-dialog"></app-photo-galleria>
